module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.6_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_react@18.3.1__react@1_2c410c854bf6922fb1e7fbc9649102e8/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
